export interface ISalutation {
  code: string;
  description: string;
  gender: string;
  maritalStatus: string;
}

export const Salutations: ISalutation[] = [
  {
    code: 'Mr',
    description: 'Mr',
    gender: 'M',
    maritalStatus: 'A',
  },
  {
    code: 'Mrs',
    description: 'Mrs',
    gender: 'F',
    maritalStatus: '1',
  },
  {
    code: 'Ms',
    description: 'Ms',
    gender: 'F',
    maritalStatus: 'A',
  },
  {
    code: 'Master',
    description: 'Master',
    gender: 'M',
    maritalStatus: 'A',
  },
  {
    code: 'Mdm',
    description: 'Mdm',
    gender: 'F',
    maritalStatus: 'A',
  },
  {
    code: 'Dr',
    description: 'Dr',
    gender: 'B',
    maritalStatus: 'A',

  },
  {
    code: 'Professor',
    description: 'Professor',
    gender: 'B',
    maritalStatus: 'A',
  }
]